import { render, staticRenderFns } from "./PricingTable.vue?vue&type=template&id=d4c180f0"
import script from "./PricingTable.vue?vue&type=script&lang=js"
export * from "./PricingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports